module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/pro_plus-7003678c.svg";